import { VFC } from 'react';
import styled from 'styled-components';

import ParamLabel from 'dashboard/components/WorkflowControlPanel/ParamLabel';
import CodeHighlight from 'dashboard/components-lib/CodeHighlight';
import { WorkflowRunStep } from 'dashboard/models/workflow-step';
import Spacer from 'design-system/components/Spacer';
import Sticker from 'design-system/components/Sticker';
import { Paragraph } from 'design-system/components/Text';
import { Variant } from 'design-system/theme';
import { ValueOf } from 'lib/utils/types';

const StyledSticker = styled(Sticker)`
  width: fit-content;
`;

const StyledCodeHighlight = styled(CodeHighlight)`
  border: 1px solid ${({ theme }) => theme.color.border.input};
  border-radius: ${({ theme }) => theme.element.borderRadius};
`;

interface ActionOutputHttpRequestV1Props {
  output: Exclude<
    ValueOf<WorkflowRunStep['attributes']['known-variables-map']>['output'],
    '' | null
  >;
}

const ActionOutputHttpRequestV1: VFC<ActionOutputHttpRequestV1Props> = ({ output }) => {
  const {
    result,
    'response-status': statusCode,
    'request-body': requestBody,
    'request-url': requestUrl,
  } = output;
  const [stickerVariant, httpRequestStepResultDisplayStatus]: [Variant, string] =
    Number(statusCode) >= 200 && Number(statusCode) < 300
      ? ['success', 'Success']
      : ['danger', 'Error'];

  return (
    <>
      <ParamLabel labelText='Status' htmlFor='action-output-http-request__status' />
      <output id='action-output-http-request__status'>
        <StyledSticker variant={stickerVariant}>
          {httpRequestStepResultDisplayStatus}:&nbsp;{statusCode}
        </StyledSticker>
      </output>
      {result && (
        <>
          <Spacer height={2} />
          <ParamLabel
            labelText='Response Body'
            htmlFor='action-output-http-request__response-body'
          />
          <output id='action-output-http-request__response-body'>
            <StyledCodeHighlight language='json' light>
              {JSON.stringify(result, null, 2)}
            </StyledCodeHighlight>
          </output>
        </>
      )}
      {requestUrl && (
        <>
          <Spacer height={2} />
          <ParamLabel labelText='Request URL' htmlFor='action-output-http-request__request-url' />
          <output id='action-output-http-request__request-url'>
            <Paragraph>{requestUrl}</Paragraph>
          </output>
        </>
      )}
      {requestBody && (
        <>
          <Spacer height={2} />
          <ParamLabel labelText='Request Body' htmlFor='action-output-http-request__request-body' />
          <output id='action-output-http-request__request-body'>
            <StyledCodeHighlight language='json' light>
              {requestBody}
            </StyledCodeHighlight>
          </output>
        </>
      )}
    </>
  );
};

export default ActionOutputHttpRequestV1;
